module.exports = __webpack_public_path__ + "img/SlideShow01.7a6d762f.jpg";